<template>
    <div id="buy-membership-plan-container">
        <div class="text-center" v-if="loading">
            <div class="preloader"></div>
        </div>

        <div v-else>
            <div class="row" v-if="membershipPlan && !showMembershipPurchaseConfirmation">
                <div class="col-md-4">
                    <online-booking-sidebar-steps
                        :title="trans('online_booking.memberships.title')"
                    />
                </div>
                <div class="col-md-8">
                    <div
                        class="panel-group"
                        id="event-accordion"
                        role="tablist"
                        aria-multiselectable="true"
                    >
                        <fill-information-memberships></fill-information-memberships>
                        <confirm-membership-plan></confirm-membership-plan>
                        <membership-plan-payment></membership-plan-payment>
                    </div>
                </div>
            </div>

            <transition name="slideUpConfirm">
                <div class="row">
                    <div class="col-md-10">
                        <membership-plan-success v-show="showMembershipPurchaseConfirmation"></membership-plan-success>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>


<script>
import { http } from '@/system/http';
import { mapActions } from 'vuex';
import { bookingModules } from '@/online_booking/new/helpers/constants';
import FillInformationMemberships from '@/online_booking/new/components/memberships/FillInformationMemberships.vue';
import ConfirmMembershipPlan from '@/online_booking/new/components/memberships/ConfirmMembershipPlan.vue';
import MembershipPlanPayment from '@/online_booking/new/components/memberships/MembershipPlanPayment.vue';
import MembershipPlanSuccess from '@/online_booking/new/components/memberships/MembershipPlanSuccess.vue';
import OnlineBookingSidebarSteps from '@/online_booking/new/components/common/OnlineBookingSidebarSteps.vue';

export default {
    data() {
        return {
            slug: null,
            loading: false,
            membershipPlan: null,
            purchase: null,
            showMembershipPurchaseConfirmation: false,
        }
    },

    mounted() {
        this.slug = this.$route.params.slug;
        this.setCurrentModule(bookingModules.BOOK_SUBSCRIPTION);

        this.$event_bus.$on('infoMembershipAdded', (data) => {
            this.purchase = data.purchase;
            this.showMembershipPurchaseConfirmation = true;
        });

        this.init();
    },

    methods: {
        ...mapActions('OnlineBooking', ['setCurrentModule']),

        init () {
            this.loading = true;

            const url = '/subscription/' + this.$route.params.slug + '/get';

            http.get(url)
                .then(({data}) => {
                    this.membershipPlan = data.membership_plan;
                    this.purchase = data.membership_subscription;
                    this.loading = false;

                    this.$nextTick(() => {
                        this.$event_bus.$emit('LoadMembershipData', data);
                    });
                })
                .catch(() => {
                    this.loading = false;
                });
        },
    },

    computed: {
        query_params() {
            let params = {};
            let queryStringSplit = window.location.search.replace(/^\?/, '').split('&');

            queryStringSplit.forEach(queryParam => {
                let [key, value] = queryParam.split('=');
                params[key] = value;
            });

            return params;
        },
    },

    components: {
        ConfirmMembershipPlan,
        MembershipPlanPayment,
        MembershipPlanSuccess,
        OnlineBookingSidebarSteps,
        FillInformationMemberships,
    }
}
</script>
